import { publicEnv } from '@/utils/public-env'

// Derive the runtime environment for analytics. Returns a stable bucket name
// that GA can segment on (`prod` | `stage` | `dev`).
//
// We rely on NEXT_PUBLIC_AUTH_URL because it is baked into the client bundle
// per-build and already differs across environments. APP_ENV is server-side
// only and not available to the browser.

export type AppEnvironment = 'prod' | 'stage' | 'dev'

export function getAppEnvironment(): AppEnvironment {
  const url = publicEnv('NEXT_PUBLIC_AUTH_URL') ?? ''
  if (url.includes('atlas.stage.worldvue.com')) return 'stage'
  if (url.includes('atlas.worldvue.com')) return 'prod'
  return 'dev'
}
